import { useCallback, useEffect, useSyncExternalStore } from 'react';
import type { ConversationId } from '@cyphex/types';
import { outboxStore } from '../store/outboxStore';
import type { OutboxItem } from '../types';

const EMPTY: readonly OutboxItem[] = [];

/** Pending sends for one conversation. Snapshot identity is stable between mutations. */
export function useOutbox(conversationId: ConversationId | null): readonly OutboxItem[] {
  useEffect(() => {
    void outboxStore.hydrate();
  }, []);

  const subscribe = useCallback((listener: () => void) => outboxStore.subscribe(listener), []);
  const snapshot = useCallback(
    () => (conversationId ? outboxStore.select(conversationId) : EMPTY),
    [conversationId],
  );

  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
